// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"styles_confirmModal__3LogT","overlayConfirmModal":"styles_overlayConfirmModal__233Nl","buttonContainer":"styles_buttonContainer__3tbcR"};